module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921121149_T.04d587a5.jpg";